import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../../button";
import Input from "../../form/input";
import * as yup from "yup";

interface Inputs {
  cancelDescription: string;
}

interface Props {
  onSubmit: (data: Inputs) => void;
  close: () => void;
}

const validations = yup.object({
  cancelDescription: yup.string().required("این فیلد الزامی است"),
});

const CancelDialog: React.FC<Props> = (props) => {
  const resolver = yupResolver(validations);
  const { onSubmit, close } = props;
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>({ resolver, defaultValues: { cancelDescription: "" } });

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="p-8 pt-16">
          <p>آیا از لغو نوبت خود مطمئن هستید؟</p>
          <Input
            label="علت لغو"
            required
            inputClassName="m-1"
            error={errors?.cancelDescription}
            {...register("cancelDescription")}
            placeholder="علت لغو خود را توضیح دهید"
          />
        </div>
        <div className="flex">
          <Button
            loading={isSubmitting}
            variant="outline"
            className="w-full rounded-none !text-pkc-primary !border-pkc-primary rounded-br-3xl"
          >
            بله
          </Button>
          <Button onClick={close} type="button" variant="contained" className="w-full !rounded-none">
            نه
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CancelDialog;
